import { QuoteReservation } from '@/models/quote.ts'

export const getReservationSpotId = (reservation: QuoteReservation) => {
  return `_${reservation.spotName}_${reservation.spotType}`
}
